import { z } from "zod";

export const passwordSchema = z
  .object({
    password: z
      .string()
      .min(1, "validation.passwordRequired")
      .min(6, "validation.passwordMinLength"),

    confirmPassword: z
      .string()
      .min(1, "validation.passwordRequired")
      .min(6, "validation.passwordMinLength"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "validation.passwordsMismatch",
    path: ["confirmPassword"],
  });

export type PasswordSchemaType = z.infer<typeof passwordSchema>;
